module.exports = __webpack_public_path__ + "static/media/37-7.6929dc9a.mp3";